import React, {createElement} from 'react';
import {Reminder} from './reminder';
import {Tag, FormField, Flex, DynamicContainer, TimePicker, List} from 'components';
import {ordinalize, first, split, sortBy, range, minutes, toggle, uniq, includes, useFormikContext} from 'helpers';
import {activities} from 'store';
import {Form} from 'formik';

export function Time(props) {
  const { values } = useFormikContext();
  return createElement(activities.perDay(values.repetition) > 1 ? Multiple : Single, props);
}

function Single({ label }) {
  const { values, setFieldValue } = useFormikContext();
  const value = values.time ? values.time : values.dayParts ? { dayParts: values.dayParts } : null;
  const setValue = time => {
    if (time && time.dayParts) {
      setFieldValue('time', null);
      setFieldValue('dayParts', time.dayParts);
    } else {
      setFieldValue('time', time);
      setFieldValue('dayParts', null);
    }
  }
  return (
    <div>
      <TimePicker label={label} value={value} setValue={setValue} hasDayParts />
      <Reminder />
    </div>
  );
}

function Multiple() {
  const { values, setFieldValue } = useFormikContext();
  const perDay = activities.perDay(values.repetition);
  let times = split(values.times, ', ').filter(Boolean);
  let dayParts = values.dayParts || uniq(times.map(time => activities.dayParts({ time}))).join(', ');

  const setValue = (value, index) => {
    if (value && value.dayParts) {
      setFieldValue('time', null);
      setFieldValue('times', null);
      setFieldValue('dayParts', toggle(dayParts, value.dayParts, {
        separator: ', ',
        sort: value => ['Morning', 'Afternoon', 'Evening'].indexOf(value),
        max: perDay,
      }));
    } else {
      times[index] = value;
      times = sortBy(uniq(times.filter(Boolean)), minutes);
      setFieldValue('dayParts', null);
      setFieldValue('time', first(times));
      setFieldValue('times', times.join(', '));
    }
  }

  return (
    <DynamicContainer>
      <List group>
        { range(0, Math.min(times.length + 1, perDay)).map(index =>
          <TimePicker key={index} label={times[index] ? `${ordinalize(index+1)} repetition` : (index ? 'Add repetition..' : 'Time')} value={times[index]} setValue={value => setValue(value, index)} />
        ) }
        <FormField Wrapper="div">
          <FormField.Label>Part of the day</FormField.Label>
          <Flex align-self-center small-gutter>
            <Tag onClick={() => setValue({ dayParts: 'Morning' })} selected={includes(dayParts, 'Morning')}>Morning</Tag>
            <Tag onClick={() => setValue({ dayParts: 'Afternoon' })} selected={includes(dayParts, 'Afternoon')}>Afternoon</Tag>
            <Tag onClick={() => setValue({ dayParts: 'Evening' })} selected={includes(dayParts, 'Evening')}>Evening</Tag>
          </Flex>
        </FormField>
      </List>
      <Reminder />
    </DynamicContainer>
  );
}
